/*
    generate by magix-combine: https://github.com/thx/magix-combine
    author: xinglie.lkf@alibaba-inc.com; kooboy_li@163.com
 */
/*
    generate by magix-combine: https://github.com/thx/magix-combine
    author: xinglie.lkf@alibaba-inc.com; kooboy_li@163.com
 */
/*
    generate by magix-combine: https://github.com/thx/magix-combine
    author: xinglie.lkf@alibaba-inc.com; kooboy_li@163.com
 */
/**
 * 对话框
 * @author weikang.zhuwk@alibaba-inc.com
 *
 * @param {string} [title] 标题默认为空 ''
 * @param {boolean} [show] 是否直接显示 false
 * @param {string} [view] 是否使用子view ''
 * @param {string} [viewOptions] 子view的配置参数
 * @param {string} [content] 内容 ''
 * @param {boolean} [preventScroll] 是否阻止背景滚动 true
 * @param {string} [closable] 是否显示右上角的关闭按钮 true
 * @param {string} [closeDestroy] 关闭弹框是不是自动销毁 false
 * @param {string} [maskClosable] 是否点击蒙层关闭 true
 * @param {string} [animate] 动画 为空则没有动画 可选 
 * @param {string} [elCls] 根节点class名 ''
 * @param {num} [zIndex] z-index的值
 * @param {string} [width] 弹框的宽度 '80%'
 * @param {string} [height] 弹框的高度 auto
 * @param {string} [autoCloseMs] 间隔autoCloseMs后自动关闭，默认不自动关闭 ''
 * @param {string} [pos] dialog显示位置，可选值[top|left|right|bottom]，默认水平垂直居中, ''
 * @param {boolean} [showMask] 是否显示mask true
 * @param {string} [cancelBtnMsg] 取消按钮文案
 * @param {string} [okBtnMsg] 确认按钮文案
 *
 * @event {string} [close] 关闭弹框事件
 * @event {string} [open] 打开弹框事件
 *
 * @method [open] 打开弹框
 * @method [close] 关闭弹框
 * @method [setHtml] 更换内容
 *
 * @static create 以一个初始化配置创建一个对话框
 *
 */
var posAniMap = {
  top: 'slideInTop',
  right: 'slideInRight',
  bottom: 'slideInBottom',
  left: 'slideInLeft'
};

Magix.applyStyle("mx-af-cell-dialog", ".cell-dialog-hide body{position:fixed;width:100%}.cell-dialog-wrap{display:none;position:fixed;overflow:auto;top:0;right:0;bottom:0;left:0;height:100%;-webkit-overflow-scrolling:touch;outline:0;opacity:0;background-color:rgba(34,34,34,.6);transition:opacity .3s;z-index:999}.cell-dialog-wrap.no-mask{background-color:transparent}.cell-dialog-wrap .cell-dialog{width:80%;position:relative;background:#fff;border-radius:.1rem;font-size:.36rem;overflow:hidden}.cell-dialog-wrap .cell-dialog .cell-dialog-title{text-align:center;font-size:.4rem;padding:.2rem}.cell-dialog-wrap .cell-dialog .cell-dialog-content{padding:.2rem .4rem}.cell-dialog-wrap .cell-dialog .cell-dialog-close{position:absolute;right:3%;top:5%;color:#333;height:.4rem;line-height:.4rem}.cell-dialog-wrap .cell-dialog .cell-dialog-close:after{content:\"\\D7\";font-weight:100;font-size:.4rem}.cell-dialog-wrap .cell-dialog-btns{display:-webkit-box;display:box;display:flex;border-top:1px solid #ccc;font-size:.4rem;text-align:center}.cell-dialog-wrap .cell-dialog-btns .dlg-btn{box-flex:1;-moz-flex:1;flex:1;color:#666;background-color:#fff;padding:0;height:1rem;line-height:1rem;border-right:1px solid #ccc}.cell-dialog-wrap .cell-dialog-btns .dlg-btn:last-child{border-right:none}.cell-dialog-wrap .cell-dialog-btns .dlg-btn.btn-ok{color:#fb3434}.cell-dialog-wrap .cell-dialog{opacity:0}.cell-dialog-wrap .cell-dialog.fadeInScale{transform:scale(.7);opacity:0;transition:all .3s}.cell-dialog-wrap .cell-dialog.slideInRight{transform:translateX(20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-wrap .cell-dialog.slideInLeft{transform:translateX(-20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-wrap .cell-dialog.slideInBottom{transform:translateY(20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-wrap .cell-dialog.slideInTop{transform:translateY(-20%);opacity:0;transition:all .3s cubic-bezier(.25,.5,.5,.9)}.cell-dialog-show{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center}.cell-dialog-show.pos-top{box-align:start;align-items:flex-start}.cell-dialog-show.pos-right{box-pack:end;justify-content:flex-end}.cell-dialog-show.pos-bottom{box-align:end;align-items:flex-end}.cell-dialog-show.pos-left{box-pack:start;justify-content:flex-start}.cell-dialog-animate,.cell-dialog-animate .cell-dialog{opacity:1}.cell-dialog-animate .cell-dialog.fadeInScale{transform:scale(1);opacity:1}.cell-dialog-animate .cell-dialog.slideInBottom,.cell-dialog-animate .cell-dialog.slideInLeft,.cell-dialog-animate .cell-dialog.slideInRight,.cell-dialog-animate .cell-dialog.slideInTop{transform:translateX(0);opacity:1}");
function movePrevent(e) {
  if (e.preventDefault) {
    e.preventDefault();
  }
}

function closeFn() {
  this.close && this.close();
}

module.exports = Magix.View.extend({
  tmpl: "<div class=\"cell-dialog <%= animated %> <%= elCls %>\" style=\"<%if(width){%>width:<%= width %>;<%}%><%if(height){%>height:<%= height %>;<%}%>\"> <% if(title){ %> <div class=\"cell-dialog-title\"><div class=\"title\"><%! title %></div></div> <% } %> <% if(content){ %> <div class=\"cell-dialog-content\"><%! content %></div> <% } %> <% if(view){ %> <div id=\"dialog_subview_of_<%= ownerid %>\" class=\"cell-dialog-content\" mx-view></div> <% } %> <% if(okBtnMsg || cancelBtnMsg){%> <div class=\"cell-dialog-btns\"> <% if(cancelBtnMsg){%> <div class=\"dlg-btn btn-cancel\" mx-click=\"cancelBtnClick()\"><%! cancelBtnMsg %></div> <% } %> <% if(okBtnMsg){%> <div class=\"dlg-btn btn-ok\" mx-click=\"okBtnClick()\"><%! okBtnMsg %></div> <% } %> </div> <% } %> <% if(closable){ %> <div class=\"cell-dialog-close\" mx-click=\"close()\"></div> <% } %> </div>",
  ctor: function ctor(e) {
    var me = this;
    var options = e.options || {};
    var pos = options.pos;
    if (!options.animated && posAniMap[pos]) {
      options.animated = posAniMap[pos];
    }
    me.$options = $.extend({
      width: '',
      height: '',
      zIndex: '',
      closable: true,
      closeDestroy: false,
      maskClosable: true,
      elCls: '',
      view: '',
      viewOptions: {},
      content: '',
      show: false,
      animated: 'fadeInScale', // fadeInScale slideInRight slideInLeft slideInTop
      title: '',
      preventScroll: true,
      preventType: 'preventDefault', // fixed preventDefault
      autoCloseMs: '',
      pos: '',
      showMask: true,
      okBtnMsg: '',
      cancelBtnMsg: '',
      okBtnCallback: closeFn,
      cancelBtnCallback: closeFn
    }, options);

    me.$options.autoCloseMs = parseInt(me.$options.autoCloseMs) || '';
    me.$el = $('#' + me.id);
    me.autoCloseTimer = null;

    me.fixOptions(me.$options);
    me.$relatedElement = $('#' + me.id);
    me.$relatedElement.addClass('cell-dialog-wrap');
    me.on('destroy', function () {
      $('#' + me.id).remove();
    });
  },
  // 属性的特殊处理，比如width这种px的处理
  fixOptions: function fixOptions(options) {
    if (options.width && /\d$/.test(options.width)) {
      options.width += 'px';
    }
    if (options.height && /\d$/.test(options.height)) {
      options.height += 'px';
    }
  },
  render: function render() {
    var me = this;
    me.$options.ownerid = me.id;
    var pos = me.$options.pos;

    if (pos) {
      me.$el.addClass('pos-' + pos);
    }
    if (!me.$options.showMask) {
      me.$el.addClass('no-mask');
    }

    var html = $.tmpl(me.tmpl, me.$options);
    me.setHTML(me.id, html);

    if (me.$options.view) {
      var vf = Magix.Vframe.get('dialog_subview_of_' + me.id);
      if (vf) {
        vf.mountView(me.$options.view, me.$options.viewOptions);
      }
    }
    // 一些特殊配置的处理
    me.$options.zIndex && me.$relatedElement.css('zIndex', me.$options.zIndex);
    if (me.$options.show) {
      me.open();
    }
    if (me.$options.maskClosable) {
      me.$relatedElement.on('click', function (e) {
        if (!$.contains(me.$relatedElement[0], e.target)) {
          me.close();
        }
      });
    }
  },
  open: function open() {
    var me = this;
    me.$relatedElement.addClass('cell-dialog-show');
    setTimeout(function () {
      me.$relatedElement.addClass('cell-dialog-animate');
    }, 10);
    if (me.$options.preventScroll && me.$options.preventType == 'fixed') {
      $('html').addClass('cell-dialog-hide');
    }
    if (me.$options.preventScroll && me.$options.preventType == 'preventDefault') {
      $('#' + me.id).on('touchmove', movePrevent);
    }
    $('#' + me.id).trigger({
      type: 'open',
      value: ''
    });
    if (me.$options.autoCloseMs) {
      clearTimeout(me.autoCloseTimer);
      me.autoCloseTimer = setTimeout(function () {
        me.close();
      }, me.$options.autoCloseMs);
    }
  },
  close: function close(cb) {
    var me = this;
    me.$relatedElement.removeClass('cell-dialog-animate');
    // 防止点击穿透
    setTimeout(function () {
      if (me.$options.closeDestroy) {
        me.destroy();
      } else {
        me.$relatedElement.removeClass('cell-dialog-show');
      }
      if (me.$options.preventScroll && me.$options.preventType == 'fixed') {
        $('html').removeClass('cell-dialog-hide');
      }
      if (me.$options.preventScroll && me.$options.preventType == 'preventDefault') {
        $('#' + me.id).off('touchmove', movePrevent);
      }
      $('#' + me.id).trigger({
        type: 'close',
        value: ''
      });
    }, 300);
    clearTimeout(me.autoCloseTimer);
    me.autoCloseTimer = null;
  },
  setHtml: function setHtml(html, $el) {
    //修改dialog某处的内容
    $el = $($el);
    if ($el.length < 1) {
      $el = this.$el.find('.cell-dialog-content').eq(0);
    }
    $el.html(html);
  },
  'okBtnClick<click>': function okBtnClickClick(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (this.$options.okBtnCallback) {
      this.$options.okBtnCallback.call(this);
    }
  },
  'cancelBtnClick<click>': function cancelBtnClickClick(e) {
    if (e.preventDefault) {
      e.preventDefault();
    }
    if (this.$options.cancelBtnCallback) {
      this.$options.cancelBtnCallback.call(this);
    }
  },
  'close<click>': function closeClick(e) {
    var me = this;
    me.close();
  },
  destroy: function destroy() {
    this.owner.unmountVframe();
  }
}, {
  create: function create(params) {
    var rootId = Magix.config('rootId');
    var owner = params.owner || Magix.Vframe.get(rootId);
    var id = 'cell' + Magix.guid('dlg_');
    var $parent = $(params.parentEl);
    if ($parent.length < 1) {
      $parent = $('body');
    }
    if (params.el) {
      id = params.el;
    } else {
      $parent.append('<div class="cell-dialog-wrap" id="' + id + '"/>');
    }
    var path = this.__moduleid__ || 'cell-dialog';
    owner.mountVframe(id, path, params);
    return $('#' + id);
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_cell-dialog@0.0.17@@ali/cell-dialog/index.js
// module id = 1
// module chunks = 1 2 3